export default {
  tip_client_label: 'Client type',
  tip_client_casnic: 'Household',
  tip_client_casnic_hint: '',
  tip_client_non_casnic: 'Non-household',
  tip_client_non_casnic_hint: 'Non-household customer with an average number of employees less than 50 and an annual turnover or total asset value in the balance sheet, according to annual tax reports, which does not exceed EUR 10 million',
  tip_client_non_casnic_fara: 'Nonhousehold - customed',
  tip_client_non_casnic_fara_hint: 'Non-household customer who does not meet the requirement for an average number of employees less than 50 and annual turnover or total asset value in the balance sheet, according to annual tax reports not exceeding € 10 million ',
  tip_client_rule_required: 'Type of customer is required.',
  tip_client_rule_in: 'Client Type is invalid.',

  tip_oferta_label: 'Offer type',
  tip_oferta_oricare: 'Any',
  tip_oferta_concurentiala: 'Competitive offers',
  tip_oferta_serviciu_universal: 'Offers universal service',
  tip_oferta_rule_required: 'Offers type is required',
  tip_oferta_rule_in: 'Offers type is invalid.',

  tip_produs_label: 'Product type',
  tip_produs_oricare: 'Any',
  tip_produs_fix: 'Fixed price for the entire contractual period',
  tip_produs_variabil: 'Variable price',
  tip_produs_rule_required: 'Product type is required',
  tip_produs_rule_in: 'Product type is invalid.',

  valoare_fixa_label: 'Offers that include a fixed component',
  valoare_fixa_oricare: 'Any',
  valoare_fixa_da: 'yes',
  valoare_fixa_nu: 'no',
  valoare_fixa_rule_in: '',

  valoare_factura_curenta_label: 'The value of the current invoice for comparison (lei)',
  valoare_factura_curenta_required: 'The value of the current invoice for comparison (lei) is required',

  consum_lunar_label: 'Monthly consumption',
  consum_lunar_rule_required: 'Monthly consumption is mandatory.',
  consum_lunar_rule_number: 'Monthly consumption must be a positive whole number',

  judet_label: 'County',
  judet_rule_required: 'The county is obligatory',

  data_start_aplicare_label: 'Date from which the offer applies',
  data_start_aplicare_rule_required: 'Date from which the offer applies is mandatory.',

  nivel_tensiune_label: 'Voltage level',
  nivel_tensiune_inalt: 'High voltage',
  nivel_tensiune_mediu: 'Medium voltage',
  nivel_tensiune_jos: 'Low voltage',
  nivel_tensiune_rule_required: 'Voltage level is mandatory.',
  nivel_tensiune_rule_in: 'Voltage level is invalid',

  perioada_contract_label: 'Contract period',
  perioada_contract_oricare: 'Any',
  perioada_contract_sub_1_an: 'less than 1 year',
  perioada_contract_1_an: 'one year',
  perioada_contract_intre_1_an_si_2_ani: 'between 1 and 2 years',
  perioada_contract_2_ani: 'two years',
  perioada_contract_intre_2_ani_si_3_ani: 'between 2 and 3 years',
  perioada_contract_3_ani: 'three years',
  perioada_contract_mai_mare_de_3_ani: 'older than 3 years',
  perioada_contract_nedeterminata: 'unlimited',
  perioada_contract_rule_required: 'The contractual period is mandatory.',
  perioada_contract_rule_in: 'The contract period is invalid',

  tip_pret_label: 'Price type',
  tip_pret_nediferentiat: 'undifferentiated',
  tip_pret_diferentiat: 'Differentiated on hourly zones',
  tip_pret_rule_required: 'Price type is required.',
  tip_pret_rule_in: 'The price type is invalid.',

  factura_electronica_label: 'Invoice delivery mode',
  factura_electronica_oricare: 'Any',
  factura_electronica_posta: 'Mail / Courier',
  factura_electronica_email: 'E-mail',
  factura_electronica_portal: 'Portal',
  factura_electronica_posta_si_email: 'Mail / courier and electronic',
  factura_electronica_rule_required: 'The electronic invoice is mandatory.',
  factura_electronica_rule_in: 'The electronic invoice is invalid.',

  pret_oferta_diferentiat_label: '',
  pret_oferta_diferentiat_zi_rule_required: 'Percentage of daily area consumption is mandatory',
  pret_oferta_diferentiat_zi_rule_number: 'The daily area consumption percentage should be a positive whole number.',
  pret_oferta_diferentiat_zi_rule_between: 'The daily area consumption percentage must be between 0 and 100.',

  frecventa_emitere_factura_label: 'Frequency issuing invoice',
  frecventa_emitere_factura_oricare: 'Any',
  frecventa_emitere_factura_lunar: 'Monthly',
  frecventa_emitere_factura_2_luni: 'at two months',
  frecventa_emitere_factura_3_luni: 'at three months',
  frecventa_emitere_factura_altele: 'others',
  frecventa_emitere_factura_rule_in: 'Frequency of issuing the invoice is invalid.',

  frecventa_citire_contor_label: 'Counter reading frequency',
  frecventa_citire_contor_oricare: 'Any',
  frecventa_citire_contor_lunar: 'monthly',
  frecventa_citire_contor_2_luni: 'every 2 months',
  frecventa_citire_contor_3_luni: 'every 3 months',
  frecventa_citire_contor_4_luni: 'every 4 months',
  frecventa_citire_contor_5_luni: 'every 5 months',
  frecventa_citire_contor_6_luni: 'every 6 months',
  frecventa_citire_contor_rule_in: 'Counter reading frequency is invalid.',

  energie_sursa_regenerabile_label: 'Energy from renewable sources',
  energie_sursa_regenerabile_oricare: 'Any',
  energie_sursa_regenerabile_da: 'yes',
  energie_sursa_regenerabile_nu: 'no',
  energie_sursa_regenerabile_rule_in: '',

  compara_preturi_label: 'Compare prices',

  documente_client_nou_label: 'New client (new construction, change of owner, etc.)',
  documente_client_furnizor_existent: 'Change of contract conditions (change of contract type, new offer, contract extension, etc.)',
  documente_client_furnizor_nou: 'Change supplier',

  completati_factura_curenta: '(fill in the current invoice value)',
}
